// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IEmissionAreaType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class EmissionAreaType implements IEmissionAreaType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Area A Non-Attainment  EmissionAreaType
	**/
    get A(): IEmissionAreaType {
        return this.FromId(1);
    }
    /**
		Returns Area B Non-Attainment EmissionAreaType
	**/
    get B(): IEmissionAreaType {
        return this.FromId(2);
    }
    /**
		Returns Exempt EmissionAreaType
	**/
    get EmissionsExempt(): IEmissionAreaType {
        return this.FromId(3);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'A', displayValue: 'Area A Non-Attainment ', description: 'Area A Non-Attainment ', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'B', displayValue: 'Area B Non-Attainment', description: 'Area B Non-Attainment', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'EmissionsExempt', displayValue: 'Exempt', description: 'Exempt', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IEmissionAreaType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IEmissionAreaType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IEmissionAreaType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IEmissionAreaType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IEmissionAreaType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
